import { OptionDto } from "@/dtos";
import { IncidencePriority } from "@/helpers/types";

const priorities = [
    { value: IncidencePriority.HIGH, label: 'Alto' },
    { value: IncidencePriority.MEDIUM, label: 'Medio' },
    { value: IncidencePriority.LOW, label: 'Bajo' },
] as OptionDto[];

export const getPriorityOptions = (): OptionDto[] => {
    return priorities;
}

export const getPriorityOption = (value?: number): OptionDto => {
    return priorities.find((x) => x.value == value) ?? priorities[0];
}